export default "__VITE_ASSET__B_nv2aln__"